import type { OnyxIconName } from '../icons/interfaces';
import { OnyxToastMessage, OnyxToastIntent } from './enums';

export const ONYX_TOASTS_LIMIT = 3;

export const DEFAULT_TOAST_INTENTS: Record<OnyxToastMessage, OnyxToastIntent> =
  {
    [OnyxToastMessage.INVALID_DATA]: OnyxToastIntent.ERROR,
    [OnyxToastMessage.SERVER_ERROR]: OnyxToastIntent.ERROR,
    [OnyxToastMessage.SAVED_CHANGES]: OnyxToastIntent.SUCCESS,
    [OnyxToastMessage.UPDATED_DATA]: OnyxToastIntent.SUCCESS,
    [OnyxToastMessage.COPIED_TO_CLIPBOARD]: OnyxToastIntent.INFORMATION,
    [OnyxToastMessage.FORM_CHANGES_RESTORED]: OnyxToastIntent.INFORMATION,
  } as const;

export const DEFAULT_TOAST_ICONS: Partial<
  Record<OnyxToastMessage, OnyxIconName>
> = {
  [OnyxToastMessage.COPIED_TO_CLIPBOARD]: 'copy-filled',
} as const;
